"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const react_intl_1 = require("react-intl");
const Utils_1 = require("./Utils");
// NB! Important side-effect! Importing this file bootstraps the locale data
require("./locale-data");
const IntlProviderWrapper = (props) => {
    let actualDefaultFormats = props.defaultFormats || Utils_1.defaultFormats;
    if (props.hour12 === false) {
        actualDefaultFormats = (0, Utils_1.setHour12)(actualDefaultFormats, false);
    }
    const wrappedProps = {
        ...props,
        defaultFormats: actualDefaultFormats,
        locale: props.locale || (0, Utils_1.getDefaultBrowserLocale)(),
        timeZone: props.timeZone || (0, Utils_1.getDefaultBrowserTimeZone)(),
    };
    return React.createElement(react_intl_1.IntlProvider, { ...wrappedProps });
};
exports.default = IntlProviderWrapper;
